export const hasVideo = (participant) => typeof participant.hasCameraAccess !== 'undefined'
    ? participant.hasCameraAccess && (participant.hasVideo || false)
    : participant.hasVideo || false;
export const hasAudio = (participant) => typeof participant.hasMicrophoneAccess !== 'undefined'
    ? participant.hasMicrophoneAccess && (participant.hasAudio || false)
    : participant.hasAudio || false;
